/// <reference lib="dom" />
import { WebPlugin } from '@capacitor/core';
export class MediaSessionWeb extends WebPlugin {
    async setMetadata(options) {
        if ('mediaSession' in navigator && navigator.mediaSession) {
            navigator.mediaSession.metadata = new MediaMetadata({
                title: options.title,
                artist: options.artist,
                album: options.album,
                artwork: options.artwork,
            });
        }
    }
    async setPlaybackState(options) {
        if ('mediaSession' in navigator && navigator.mediaSession) {
            navigator.mediaSession.playbackState = options.playbackState;
        }
    }
    async setPositionState(options) {
        if ('mediaSession' in navigator && navigator.mediaSession && 'setPositionState' in navigator.mediaSession) {
            navigator.mediaSession.setPositionState({
                duration: options.duration,
                position: options.position,
                playbackRate: options.playbackRate,
            });
        }
    }
    async setActionHandler(options) {
        if ('mediaSession' in navigator && navigator.mediaSession && 'setActionHandler' in navigator.mediaSession) {
            navigator.mediaSession.setActionHandler(options.action, () => {
                this.notifyListeners(options.action, {});
            });
        }
    }
}
//# sourceMappingURL=web.js.map